import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 19.846c-.284 0-.56-.037-.788-.12-3.502-1.2-9.066-5.463-9.066-11.76 0-3.208 2.594-5.812 5.784-5.812 1.55 0 2.998.605 4.07 1.687a5.7 5.7 0 0 1 4.07-1.687c3.19 0 5.784 2.613 5.784 5.812 0 6.307-5.564 10.56-9.066 11.76-.229.083-.504.12-.788.12M6.93 3.529c-2.43 0-4.41 1.99-4.41 4.437 0 6.26 6.023 9.744 8.14 10.468.166.055.523.055.688 0 2.109-.724 8.14-4.198 8.14-10.468 0-2.448-1.98-4.437-4.409-4.437-1.393 0-2.686.651-3.52 1.779-.256.348-.843.348-1.1 0A4.37 4.37 0 0 0 6.93 3.529"
    }, null, -1)
  ]))]))
}
export default { render: render }